import { render } from "./Folders.vue?vue&type=template&id=20f7893c&scoped=true&ts=true"
import script from "./Folders.vue?vue&type=script&lang=ts"
export * from "./Folders.vue?vue&type=script&lang=ts"

import "./Folders.vue?vue&type=style&index=0&id=20f7893c&scoped=true&lang=css"

import exportComponent from "/github/workspace/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-20f7893c"]])

export default __exports__